var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('isNoInfo',{staticClass:"view_center",attrs:{"isNolist":_vm.isNolist,"message":_vm.message}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }